// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3RpHa","title":"ClientInsurance_title__jUg8Y","itemText":"ClientInsurance_itemText__3v9az"};